import { render, staticRenderFns } from "./MiniFavorite.vue?vue&type=template&id=a66b3c56&"
import script from "./MiniFavorite.vue?vue&type=script&lang=js&"
export * from "./MiniFavorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports